import { useQuery } from '@tanstack/react-query';
import { ticketOptions } from '../../constants/tickets';
export function useTicket(id) {
    const { data, isLoading, isSuccess } = useQuery(ticketOptions.get({ id }, { withMessages: true }));
    return {
        ticket: data?.[0],
        loadingTicket: isLoading,
        isSuccess,
    };
}
